import { PrizmLanguageInputLayoutDateRelative } from '../../interfaces';

export const PRIZM_RUSSIAN_INPUT_LAYOUT_DATE_RELATIVE: PrizmLanguageInputLayoutDateRelative = {
  inputLayoutDateRelative: {
    wrongFormat: 'Неправильный формат данных',
  },
};
